let controller1 = new ScrollMagic.Controller();

//secton2 
var box2_text=document.getElementsByClassName('box2_text');
var box2_items=document.getElementsByClassName('box2_items');
let scene2 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox2', 
        triggerHook: "onenter",
        duration:0,
})
scene2.on("progress", function (event) {
    box2_items[0].classList.add("showup");
    box2_text[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box2_items[0].classList.remove("showup");
        box2_text[0].classList.remove("showup");
    }
})

//secton3
var box3_items=document.getElementsByClassName('box3_items');
let scene3 = new ScrollMagic.Scene({
        offset: -200,
        triggerElement: '.Obox3', 
        triggerHook: "onenter",
        duration:0,
})

scene3.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    
    $(window).scroll(function(){
        var Tops = $(window).scrollTop()
        var height = window.innerHeight;
        var num = Math.trunc(Tops/height*100)
        //console.log(num)
        if(num<95){
            $('.item1').css({left:'40%'})
            $('.item2').css({left:'42%'})
            $('.item3').css({left:'44%'})
            $('.item4').css({left:'46%'})
            $('.item5').css({left:'48%'})
            $('.item6').css({left:'50%'})
            $('.item7').css({left:'52%'})
            $('.item8').css({left:'54%'})
        }else if(num<110){
            $('.item1').css({left:'30%'})
            $('.item2').css({left:'35%'})
            $('.item3').css({left:'40%'})
            $('.item4').css({left:'45%'})
            $('.item5').css({left:'50%'})
            $('.item6').css({left:'55%'})
            $('.item7').css({left:'60%'})
            $('.item8').css({left:'65%'})
        }else if(num<125){
            $('.item1').css({left:'21%'})
            $('.item2').css({left:'28.5%'})
            $('.item3').css({left:'36%'})
            $('.item4').css({left:'43.5%'})
            $('.item5').css({left:'51%'})
            $('.item6').css({left:'58.5%'})
            $('.item7').css({left:'66%'})
            $('.item8').css({left:'73.5%'})
        }
    })
})

//section10
var box10_title=document.getElementsByClassName('box10_title');
let scene10 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox10',
        triggerHook: "onenter",
        duration:0,
})
scene10.on("progress", function (event) {
    box10_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){ 
        box10_title[0].classList.remove("showup");
    }
})

//section11
var box11_title=document.getElementsByClassName('box11_title');
let scene11 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Obox11',
        triggerHook: "onenter",
        duration:0,
})
scene11.on("progress", function (event) {
    box11_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){ 
        box11_title[0].classList.remove("showup");
    }
})

controller1.addScene([scene2,scene3,scene10,scene11]); 

var Mbox3swiper = new Swiper('.Mbox3swiper', {
    effect: 'fade',
    pagination: {
        el: '.r8s6img',
        clickable: true,
        renderBullet: function (index, className) {
        switch(index){
            case 0:color='linear-gradient(to bottom,#d14a66,#120709)';break;
            case 1:color='linear-gradient(to bottom,#c9c9c9,#141414)';break;
            case 2:color='linear-gradient(to bottom,#929197,#121212)';break;
            case 3:color='linear-gradient(to bottom,#64dcdf,#293bbc)';break;
            case 4:color='linear-gradient(to bottom,#cbe877,#58c76c)';break;
            case 5:color='linear-gradient(to bottom,#cbd5f5,#505abe)';break;
            case 6:color='#4a506a';break;
            case 7:color='#3b3b3b';break;
        }
        return '<span class="' + className + '" style="background:'+color+'"></span>';
        },
    },
})

$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-oneo-pod-kit'); 
})

$('.pnr_spec').click(function(){
    var element = document.querySelector(".Obox10");
    element.scrollIntoView({block: "end"});
})